export default class OverlappingBackground {
    constructor(elm, args) {
        let mobile = window.matchMedia('(min-width: 0px) and (max-width: 768px)');
        var anchor = elm.querySelectorAll(elm.dataset.overlapAnchor);
        anchor = anchor[Math.min(anchor.length - 1, 4)];
        var percentage = elm.dataset.overlapPercentage;
        var percentageMobile = elm.dataset.overlapPercentageMd;

        if (anchor) {
            var updateBackground = function () {
                var backgroundHeight = anchor.getBoundingClientRect().top - elm.getBoundingClientRect().top + anchor.offsetHeight * (percentage / 100);
                if (mobile.matches) {
                    elm.style.background = `#${elm.dataset.overlapColor};`;
                }
                else {
                    elm.style.background = `linear-gradient(180deg, #${elm.dataset.overlapColor} ${backgroundHeight}px, transparent ${backgroundHeight}px)`;
                }
            }

            window.addEventListener('resize', updateBackground);

            var imgs = elm.querySelectorAll('img')
            imgs.forEach(x => {
                if (!x.complete) {
                    x.addEventListener('load', updateBackground)
                }
            })

            window.addEventListener('swiper init', function (e) {
                updateBackground();
            }, false);

            updateBackground();
        }
    }
}
